import React, { useEffect, useState } from "react";
import {
  getBlog,
  getBlogById,
  getCategoryBlog,
  getCategoryBlogById,
} from "../axios";
import { ExitIcon } from "../assets/Icons";
import moment from "moment-jalaali";
import { useLocation, Link } from "react-router-dom";
import blogHeaderImg from "../assets/img/bg/blogsLogo.jpg";
import Pagination from "../components/common/Pagination";
import SingleBlog from "../components/SingleBlog";

// ------------- APIS -----------
// getCategoryBlog
// getCategoryBlogById

const Blog = () => {
  const [displayingBlogs, setDisplayingBlogs] = useState([]);
  const [displayingFilteredBlogs, setDisplayingFilteredBLogs] = useState([]);
  const blogsSectionEl = document.getElementById("blogs-el");

  // State and variables for pagination start
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  // State and variables for pagination end

  const [blog, setBlog] = useState([]);
  const [showAllData, setShowAllData] = useState({
    status: true,
    name: "همه ی دسته بندی ها",
    id: 0,
  });

  // ---------------------------------- GET LIST BLOG
  useEffect(() => {
    getBlog().then(({ data }) => {
      let arrayClone = Object.assign([], data);

      const reversedArray = arrayClone?.reverse();

      setBlog(reversedArray);
      setDisplayingBlogs(reversedArray?.slice(0, itemsPerPage));
    });
  }, [getBlog]);

  // ----------------------------------- GET CATEGORY LIST
  const [categoryListButton, setCategoryListButton] = useState([]);
  useEffect(() => {
    getCategoryBlog()
      .then(({ data }) => {
        setCategoryListButton(data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [getCategoryBlog]);

  const [blogListWithCategory, setBlogListWithCategory] = useState([]);
  const selectCategorHandler = (id) => {
    setCurrentPage(1);
    getCategoryBlogById(id)
      .then(({ data }) => {
        let arrayClone = Object.assign([], data);

        const reversedArray = arrayClone.reverse();

        setBlogListWithCategory(reversedArray);
        setDisplayingFilteredBLogs(reversedArray.slice(0, itemsPerPage));
      })
      .catch((err) => {
        console.log(err);
      });
    //scrolling behavior
    scrollToBlogs();
  };

  const handleFilterAll = () => {
    setShowAllData({
      status: true,
      name: "همه ی دسته بندی ها",
    });
    setCurrentPage(1);
    scrollToBlogs();
  };

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  const scrollToBlogs = () => {
    if (blogsSectionEl) {
      const topOffset =
        blogsSectionEl.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: topOffset,
        behavior: "smooth",
      });
    } else return;
  };

  //handling pagination stuff start

  useEffect(() => {
    if (showAllData.status) {
      setDisplayingBlogs(blog?.slice(startIndex, endIndex));
    } else {
      setDisplayingFilteredBLogs(
        blogListWithCategory?.slice(startIndex, endIndex)
      );
    }
  }, [currentPage, showAllData]);

  // Function to handle page change
  const handlePageChange = ({ selected }) => {
    // console.log("selected", selected + 1);
    setCurrentPage(selected + 1);
    scrollToBlogs();
  };

  //these truncating stuf is handling the blogs that came as HTML code from api
  function truncateText(text, maxLength) {
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + "...";
  }

  const slugify = (text) => {
    return text
    .trim()
    .replace(/\s*-\s*/g, "-")         // Normalize dashes surrounded by spaces
    .replace(/\s+/g, "-")             // Replace all remaining spaces with hyphens
    .replace(/-+/g, "-")              // Collapse multiple hyphens
    .replace(/[^\u0600-\u06FF\w-]/g, "") // Remove non-Persian/Arabic/word chars except hyphens
    .toLowerCase();
  }
  
  //handling the size of html blog texts came from api
  function truncateHTML(html, maxLength) {
    // Create a temporary element to parse the HTML
    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;

    // Extract the text content
    let textContent = tempElement.textContent || tempElement.innerText || "";

    // Truncate the text content
    textContent = truncateText(textContent, maxLength);
    // Return the truncated HTML
    return textContent;
  }

  return (
    <React.Fragment>
      <div className="breadcrumbs_area">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb_content">
                <ul>
                  <li>
                    <a href="/">خانه</a>
                  </li>
                  <li>بلاگ</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="blog_page_section mt-60">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="blog_wrapper">
                <div
                  className="blog_header bg-light w-100 d-flex align-items-center justify-content-center shadow-sm"
                  style={{ height: "180px" }}
                >
                  <img src={blogHeaderImg} alt="Blogs" />
                </div>
                {/* --------------------------------- FILTER SECTION --------------------------------- */}

                <div className="d-flex flex-wrap justify-content-center">
                  <button
                    onClick={handleFilterAll}
                    className="all_filter_btn px-4  mr-2"
                  >
                    همه دسته بندی ها
                  </button>
                  {categoryListButton &&
                    categoryListButton?.map((item, index) => {
                      return (
                        <button
                          key={index}
                          onClick={() => {
                            selectCategorHandler(item.id);
                            setShowAllData({
                              status: false,
                              name: item.title,
                              id: item.id,
                            });
                          }}
                          className="blog_filter_btn"
                        >
                          <img src={item?.img} />
                          <p>{item.title}</p>
                        </button>
                      );
                    })}
                </div>
                <div className="mb-5 mt-5">
                  <p>دسته بندی: {showAllData.name}</p>
                </div>
                {/* --------------------------------- END FILTER SECTION --------------------------------- */}
                <div className="row" id="blogs-el">
                  {!showAllData.status &&
                    blogListWithCategory.length > 0 &&
                    displayingFilteredBlogs?.map((item, index) => (
                      <div key={index} className="col-xl-4 col-md-6 col-sm-12">
                        <Link to={`/blog/${slugify(item?.title)}`}>
                          <article className="single_blog">
                            <figure>
                              <div className="blog_thumb">
                                <a href="blog-details.html">
                                  <img src="assets/img/blog/blog1.jpg" alt="" />
                                </a>
                              </div>

                              <figcaption className="blog_content">
                                <div className="blog_img_container">
                                  <img src={item.img} alt="Blog_Image" />
                                </div>
                                <div class="blog_text_container">
                                  <p className="blog_card_title mb-0 pb-0 d-flex align-content-center justify-content-center">
                                    <span href="blog-details.html">
                                      {item.title}
                                    </span>
                                  </p>
                                  <div className="blog_desc">
                                    {item.text.includes("<") ? (
                                      <p className="blog_desc_text">
                                        <p
                                          dangerouslySetInnerHTML={{
                                            __html: truncateHTML(
                                              item.text,
                                              100
                                            ),
                                          }}
                                        ></p>
                                        <Link to={`/blog/${item.title}`}>
                                          <span className="continue-reading-btn">
                                            ادامه مطلب
                                          </span>
                                        </Link>
                                      </p>
                                    ) : (
                                      <p className="blog_desc_text">
                                        {item.text.substring(0, 100) + "..."}
                                        <Link to={`/blog/${item.title}`}>
                                          <span className="continue-reading-btn">
                                            {" "}
                                            ادامه مطلب
                                          </span>
                                        </Link>
                                      </p>
                                    )}
                                  </div>
                                  <div className="blog_meta">
                                    <span className="author">
                                      ارسال توسط :{" "}
                                      <span style={{ color: "#413cd1" }}>
                                        مدیر
                                      </span>{" "}
                                      /
                                    </span>
                                    <span className="post_date">
                                      در :{" "}
                                      <span style={{ color: "#413cd1" }}>
                                        {moment(item.date).format(
                                          "jYYYY/jM/jD"
                                        )}{" "}
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              </figcaption>
                            </figure>
                          </article>
                        </Link>
                      </div>
                    ))}
                </div>
                {blogListWithCategory.length === 0 &&
                  showAllData.status === false && (
                    <div style={{ textAlign: "center", marginTop: 20 }}>
                      مطلبی برای نمایش وجود ندارد
                    </div>
                  )}
                <div className="row" id="blogs-el">
                  {showAllData.status &&
                    blog &&
                    displayingBlogs?.map((item, index) => (
                      <div key={index} className="col-xl-4 col-md-6 col-sm-12">
                        <Link to={`/blog/${slugify(item?.title)}`}>
                          <article className="single_blog">
                            <figure>
                              <div className="blog_thumb">
                                <a href="blog-details.html">
                                  <img src="assets/img/blog/blog1.jpg" alt="" />
                                </a>
                              </div>
                              <figcaption className="blog_content">
                                <div className="blog_img_container">
                                  <img src={item.img} alt="Blog_Image" />
                                </div>
                                <div className="blog_text_container">
                                  <p className="blog_card_title mb-0 pb-0 d-flex align-content-center justify-content-center">
                                    <span
                                      className="mb-0"
                                      href="blog-details.html"
                                    >
                                      {item.title}
                                    </span>
                                  </p>
                                  <div className="blog_desc">
                                    {item.text.includes("<") ? (
                                      <p className="blog_desc_text">
                                        <p
                                          dangerouslySetInnerHTML={{
                                            __html: truncateHTML(
                                              item.text,
                                              100
                                            ),
                                          }}
                                        ></p>
                                        <Link to={`/blog/${item.title}`}>
                                          <span className="continue-reading-btn">
                                            ادامه مطلب
                                          </span>
                                        </Link>
                                      </p>
                                    ) : (
                                      <p className="blog_desc_text">
                                        {item.text.substring(0, 100) + "..."}
                                        <Link to={`/blog/${item.title}`}>
                                          <span className="continue-reading-btn">
                                            {" "}
                                            ادامه مطلب
                                          </span>
                                        </Link>
                                      </p>
                                    )}
                                  </div>
                                  <div className="blog_meta">
                                    <span className="author">
                                      ارسال توسط :{" "}
                                      <span style={{ color: "#413cd1" }}>
                                        مدیر
                                      </span>{" "}
                                      /
                                    </span>
                                    <span className="post_date">
                                      در :{" "}
                                      <span style={{ color: "#413cd1" }}>
                                        {moment(item.date).format(
                                          "jYYYY/jM/jD"
                                        )}
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              </figcaption>
                            </figure>
                          </article>
                        </Link>
                      </div>
                    ))}
                </div>
                <Pagination
                  totalItems={
                    showAllData.status
                      ? blog.length
                      : blogListWithCategory.length
                  }
                  itemsPerPage={itemsPerPage}
                  onPageChange={handlePageChange}
                  currentPage={currentPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="blog_pagination">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="pagination">
                <ul>
                  <li className="current">
                    <span>1</span>
                  </li>
                  <li>
                    <a href="#">2</a>
                  </li>
                  <li>
                    <a href="#">3</a>
                  </li>
                  <li className="next">
                    <a href="#">بعدی</a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fa fa-angle-double-left"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </React.Fragment>
  );
};

export default Blog;
